"use client";

import { usePostHog } from "posthog-js/react";
import type { ComponentProps, ReactNode } from "react";

type SchoolTrackedLinkProps = Omit<ComponentProps<"a">, "children"> & {
  children: ReactNode;
  placement: string;
};

export function SchoolTrackedLink({
  children,
  onClick,
  placement,
  ...props
}: SchoolTrackedLinkProps) {
  const posthog = usePostHog();

  return (
    <a
      {...props}
      onClick={(event) => {
        posthog?.capture("schools_primary_cta_clicked", { placement });
        onClick?.(event);
      }}
    >
      {children}
    </a>
  );
}
